var _style, _rect, _path, _circle, _path2, _path3, _rect2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600 900",
    style: {
      enableBackground: "new 0 0 1600 900"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0E1351;}\r\n\t.st1{fill:#FFFFFF;fill-opacity:0;stroke:url(#SVGID_1_);stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;fill-opacity:0;stroke:url(#SVGID_2_);stroke-width:4;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;fill-opacity:0;stroke:url(#SVGID_3_);stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;fill-opacity:0;stroke:url(#SVGID_4_);stroke-width:4;stroke-miterlimit:10;}\r\n\t.st5{fill:#FFFFFF;fill-opacity:0;stroke:url(#SVGID_5_);stroke-width:8;stroke-miterlimit:10;}\r\n\t.st6{fill:#FFFFFF;fill-opacity:0;stroke:url(#SVGID_6_);stroke-width:4;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1600,
    height: 900
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.9416,
    y1: 881.2571,
    x2: 363.9416,
    y2: 882.2571,
    gradientTransform: "matrix(81 0 0 -70 -28031 62269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCFF66"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1409,581l41.3-70l39.7,70H1409z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.9,
    y1: 881.225,
    x2: 363.9,
    y2: 882.225,
    gradientTransform: "matrix(80 0 0 -80 -28612 70638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCFF66"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 500,
    cy: 100,
    r: 40
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.1049,
    y1: 881.4299,
    x2: 364.1049,
    y2: 882.4299,
    gradientTransform: "matrix(83.73 0 0 -41.87 -30127.5137 37640.9648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCFF66"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M400.9,735.5h-83.7c0-23.1,18.7-41.9,41.9-41.9S400.9,712.4,400.9,735.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.6401,
    y1: 882.2018,
    x2: 362.6401,
    y2: 881.2018,
    gradientTransform: "matrix(62.8 0 0 -89.2 -22623.998 79037.5859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCC00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.8,345.2l-31.4,44.6l31.4,44.6l31.4-44.6L149.8,345.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.82,
    y1: 882.18,
    x2: 364.82,
    y2: 881.18,
    gradientTransform: "matrix(100 0 0 -100 -35393 88927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCC00"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1039,
    y: 709,
    className: "st5",
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.1253,
    y1: 882.2473,
    x2: 364.1253,
    y2: 881.2473,
    gradientTransform: "matrix(84.1001 0 0 -72.8 -29238.1367 64323.6016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCC00"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1426.8,132.4l-21.1,36.4h-42l-21-36.4l21-36.4h42L1426.8,132.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/mainBg.62f7016fe8459aa7d5559ad5748db6dd.svg";
export { ForwardRef as ReactComponent };